<template>
  <!--  v-smooth-scroll="{ duration: 1000, offset: -150 }"-->
  <a href="#__nuxt"
     v-if="showScrollBtn"
     :class="['scroll-btn', {reachedTop, reachedBottom}]"
     v-smooth-scroll="{ duration: 1000, offset: -150 }"
  >

    Вверх
  </a>
</template>

<script>

  export default {
    data() {
        return {
            showScrollBtn : true
        }
      },
    methods: {
      onTopScroll(e) {
        e.preventDefault()
        return window.scrollBy({top:0,left: 0, behavior: 'smooth'});
      }
    },
    computed: {
      reachedTop() {
        return this.$store.state.scrollPosition < this.$store.state.viewportHeight;
      },
      reachedBottom() {
        const bodyHeight = document.body.clientHeight;
        return this.$store.state.scrollPosition > (bodyHeight - this.$store.state.viewportHeight - 100);
      },

    },
    created(){
      let cpc =  this.$cookie.get("cookie_policy_confirm");

      if(cpc)
         this.showScrollBtn = true;
       else
         this.showScrollBtn = false;

    },
    mounted() {
    }
  };
</script>

<style lang="scss" scoped>

  .scroll-btn {
    display: block;
    position: fixed;
    bottom: 30px;
    right: 30px;
    @include size(65px);
    background: $color-text url('/images/ui/arr-scroll-top.png') center 16px no-repeat;
    background-size: 35px;
    border-radius: 50%;
    font-size: 0;
    z-index: 400;
    &.reachedTop {
      transform: translateY(100px) !important;
    }
    &.reachedBottom {
      transform: translateY(-90px);
    }
    &:hover {
      background-color: $color-link-hover;
    }
    @media (max-width: $media_sm) {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// components/shared/ScrollTopArrow.vue